module.exports = __webpack_public_path__ + "media/images/flags/BT-cd74c0237af049d033d2e2195a4f70cc.svg";